const log = {
  init: winston => {
    const alignColorsAndTime = winston.format.combine(
      winston.format.label({
        label: "[LOGGER]"
      }),
      winston.format.timestamp({
        format: "YY-MM-DD HH:MM:SS:mmm"
      }),
      winston.format.printf(
        info =>
          ` ${info.label}  ${info.timestamp}  ${info.level} : ${info.message}`
      )
    );
    const logger = winston.createLogger({
      format: winston.format.simple(),
      transports: [
        new winston.transports.Console({
          format: winston.format.combine(alignColorsAndTime),
          handleExceptions: true,
          level: process.env.LOG_LEVEL || "info",
          prettyPrint: true,
          colorize: false,
          timestamp: true
        })
      ],
      exitOnError: false
    });
    logger.stream = {
      write: message => {
        logger.info(message);
      }
    };
    return logger;
  }
};

export default log;
